import { Box, Heading, VStack, Text, Divider, Spinner, HStack, Button } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function SPDXWidget({ files }) {
  if (!Array.isArray(files)) return null;
  const spdxFiles = files.filter(f => f.Type === 3);
  if (!spdxFiles.length) return null;
  return (
    <Box p={4} bg="gray.50" borderRadius="md" mb={4}>
      <Heading size="md" mb={2}>SPDX Report</Heading>
      <VStack align="stretch" spacing={1}>
        {spdxFiles.map((f, i) => (
          <Text key={i}>{f.FileName}</Text>
        ))}
      </VStack>
    </Box>
  );
}

function SARIFWidget({ files }) {
  if (!Array.isArray(files)) return null;
  const sarifFiles = files.filter(f => f.Type === 4);
  if (!sarifFiles.length) return null;
  return (
    <Box p={4} bg="gray.50" borderRadius="md" mb={4}>
      <Heading size="md" mb={2}>Security Scan (SARIF)</Heading>
      <VStack align="stretch" spacing={1}>
        {sarifFiles.map((f, i) => (
          <Text key={i}>{f.FileName}</Text>
        ))}
      </VStack>
    </Box>
  );
}

function UnitTestWidget({ files }) {
  if (!Array.isArray(files)) return null;
  const unitFiles = files.filter(f => f.Type === 5);
  if (!unitFiles.length) return null;
  return (
    <Box p={4} bg="gray.50" borderRadius="md" mb={4}>
      <Heading size="md" mb={2}>Unit Test Results</Heading>
      <VStack align="stretch" spacing={1}>
        {unitFiles.map((f, i) => (
          <Text key={i}>{f.FileName}</Text>
        ))}
      </VStack>
    </Box>
  );
}

function DependencyRow({ dep, descText, boxBg }) {
  const name = dep.productName;
  return (
    <Box
      as={Link}
      to={`/repo/${dep.productId}`}
      p={0}
      _hover={{ textDecoration: 'none', bg: boxBg === 'gray.50' ? 'gray.100' : 'gray.700' }}
      borderRadius="md"
      boxShadow="sm"
      display="block"
    >
      <HStack spacing={3} p={2}>
        <img
          src={`/api/icon/${dep.productId || 'default'}`}
          alt="icon"
          style={{ width: 28, height: 28, borderRadius: 4 }}
          onError={e => { e.target.src = '/api/icon/default'; }}
        />
        <Text fontWeight="medium">{name}</Text>
      </HStack>
    </Box>
  );
}

export default function BuildDetail({ repository, buildId, files }) {
  return (
    <Box>
      <Heading size="lg" mb={4}>Build Details: {repository} #{buildId}</Heading>
      <Divider mb={4} />
      <SPDXWidget files={files} />
      <SARIFWidget files={files} />
      <UnitTestWidget files={files} />
    </Box>
  );
} 